import { IApplicationState } from '../../types/redux';

export function selectBrokerFlightEnabled(state: IApplicationState) {
  return state.config.isBrokerFlightEnabled ?? undefined;
}
